export default "__VITE_ASSET__BfFBGXin__"